import React, { useContext } from 'react';
import { Snackbar as SnackbarComponent, Alert } from '@applyboard/ui-components';
import { FormStateContext } from "../FormStateProvider";
export var Snackbar = function Snackbar(_ref) {
  var openSnackbar = _ref.openSnackbar,
    message = _ref.message;
  var _useContext = useContext(FormStateContext),
    onHideError = _useContext.onHideError;
  return /*#__PURE__*/React.createElement(SnackbarComponent, {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    open: openSnackbar,
    onClose: onHideError,
    autoHideDuration: null
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "error",
    onClose: onHideError,
    "aria-label": message
  }, message));
};